'use strict';

/* ── Timezone map (module-level, shared across instances) ─────────────────── */
const _SC_TZ = {
    LDN: 'Europe/London', PAR: 'Europe/Paris', BER: 'Europe/Berlin',
    AMS: 'Europe/Amsterdam', BRU: 'Europe/Brussels', ZRH: 'Europe/Zurich',
    VIE: 'Europe/Vienna', PRG: 'Europe/Prague', BUD: 'Europe/Budapest',
    WAW: 'Europe/Warsaw', BUC: 'Europe/Bucharest', ATH: 'Europe/Athens',
    STO: 'Europe/Stockholm', OSL: 'Europe/Oslo', CPH: 'Europe/Copenhagen',
    HEL: 'Europe/Helsinki', DUB: 'Europe/Dublin', LIS: 'Europe/Lisbon',
    MAD: 'Europe/Madrid', ROM: 'Europe/Rome', IST: 'Europe/Istanbul',
    MOW: 'Europe/Moscow', KIE: 'Europe/Kiev', REY: 'Atlantic/Reykjavik',
    CAI: 'Africa/Cairo', LOS: 'Africa/Lagos', NAI: 'Africa/Nairobi',
    JNB: 'Africa/Johannesburg', DAR: 'Africa/Dar_es_Salaam',
    ACC: 'Africa/Accra', ABJ: 'Africa/Abidjan', CAS: 'Africa/Casablanca',
    ALG: 'Africa/Algiers', ADD: 'Africa/Addis_Ababa', LUA: 'Africa/Luanda',
    NYC: 'America/New_York', CHI: 'America/Chicago', DNV: 'America/Denver',
    LAX: 'America/Los_Angeles', PHX: 'America/Phoenix', ANC: 'America/Anchorage',
    HNL: 'Pacific/Honolulu', YTZ: 'America/Toronto', YVR: 'America/Vancouver',
    MEX: 'America/Mexico_City', HAV: 'America/Havana', BOG: 'America/Bogota',
    LIM: 'America/Lima', SAO: 'America/Sao_Paulo', SCL: 'America/Santiago',
    BAI: 'America/Argentina/Buenos_Aires', CAR: 'America/Caracas',
    DXB: 'Asia/Dubai', RIY: 'Asia/Riyadh', BAG: 'Asia/Baghdad',
    TER: 'Asia/Tehran', KAR: 'Asia/Karachi', DEL: 'Asia/Kolkata',
    DHK: 'Asia/Dhaka', COL: 'Asia/Colombo', KTM: 'Asia/Kathmandu',
    RNG: 'Asia/Rangoon', BKK: 'Asia/Bangkok', SGP: 'Asia/Singapore',
    KUL: 'Asia/Kuala_Lumpur', JKT: 'Asia/Jakarta', MNL: 'Asia/Manila',
    HKG: 'Asia/Hong_Kong', TPE: 'Asia/Taipei', SHA: 'Asia/Shanghai',
    TYO: 'Asia/Tokyo', SEL: 'Asia/Seoul', URM: 'Asia/Urumqi',
    NOV: 'Asia/Novosibirsk', EKB: 'Asia/Yekaterinburg', OVB: 'Asia/Omsk',
    IKT: 'Asia/Irkutsk', YKT: 'Asia/Yakutsk', VLA: 'Asia/Vladivostok',
    SYD: 'Australia/Sydney', MEL: 'Australia/Melbourne', BNE: 'Australia/Brisbane',
    ADL: 'Australia/Adelaide', PER: 'Australia/Perth', DRW: 'Australia/Darwin',
    AKL: 'Pacific/Auckland', FJI: 'Pacific/Fiji', PPT: 'Pacific/Tahiti',
    SVA: 'Arctic/Longyearbyen', USH: 'America/Argentina/Ushuaia',
    MUR: 'Europe/Moscow', FAI: 'America/Anchorage',
};

/* --- Solstice dates (module-level) ──────────────────────────────────────────────── */
// each solistice from 2026 to 2035, in UTC, default is June 21

/* ── Summer solstice calculator (Jean Meeus, "Astronomical Algorithms") ───── */
function _scSummerSolstice(year) {
    try {
        const Y = (year - 2000) / 1000;
        // JDE of June solstice (Table 27.a, Meeus)
        const JDE = 2451716.56767
            + 365242.62510 * Y
            + 0.00325 * Y * Y
            + 0.00888 * Y * Y * Y
            - 0.00030 * Y * Y * Y * Y;
        const d = new Date((JDE - 2440587.5) * 86400000);
        // Sanity-check: result must be in May-July
        if (d.getUTCMonth() >= 4 && d.getUTCMonth() <= 6) return d;
    } catch (_) { }
    return new Date(Date.UTC(year, 5, 21)); // fallback: June 21
}

/* ── City database (module-level) ─────────────────────────────────────────── */
const _SC_DB = [
    ['London', 'United Kingdom', 51.51, -0.13, 'LDN'], ['Birmingham', 'United Kingdom', 52.49, -1.89, 'LDN'],
    ['Manchester', 'United Kingdom', 53.48, -2.24, 'LDN'], ['Glasgow', 'United Kingdom', 55.86, -4.25, 'LDN'],
    ['Liverpool', 'United Kingdom', 53.41, -2.98, 'LDN'], ['Edinburgh', 'United Kingdom', 55.95, -3.19, 'LDN'],
    ['Bristol', 'United Kingdom', 51.46, -2.60, 'LDN'], ['Leeds', 'United Kingdom', 53.80, -1.55, 'LDN'],
    ['Sheffield', 'United Kingdom', 53.38, -1.47, 'LDN'], ['Newcastle upon Tyne', 'United Kingdom', 54.98, -1.61, 'LDN'],
    ['Cardiff', 'United Kingdom', 51.48, -3.18, 'LDN'], ['Belfast', 'United Kingdom', 54.60, -5.93, 'LDN'],
    ['Nottingham', 'United Kingdom', 52.95, -1.15, 'LDN'], ['Leicester', 'United Kingdom', 52.64, -1.13, 'LDN'],
    ['Coventry', 'United Kingdom', 52.41, -1.51, 'LDN'], ['Bradford', 'United Kingdom', 53.80, -1.75, 'LDN'],
    ['Wolverhampton', 'United Kingdom', 52.59, -2.11, 'LDN'], ['Plymouth', 'United Kingdom', 50.37, -4.14, 'LDN'],
    ['Southampton', 'United Kingdom', 50.90, -1.40, 'LDN'], ['Derby', 'United Kingdom', 52.92, -1.48, 'LDN'],
    ['Swansea', 'United Kingdom', 51.62, -3.94, 'LDN'], ['Aberdeen', 'United Kingdom', 57.15, -2.11, 'LDN'],
    ['Inverness', 'United Kingdom', 57.48, -4.22, 'LDN'], ['Oxford', 'United Kingdom', 51.75, -1.26, 'LDN'],
    ['Cambridge', 'United Kingdom', 52.20, 0.12, 'LDN'], ['Brighton', 'United Kingdom', 50.83, -0.14, 'LDN'],
    ['Bath', 'United Kingdom', 51.38, -2.36, 'LDN'], ['York', 'United Kingdom', 53.96, -1.08, 'LDN'],
    ['Exeter', 'United Kingdom', 50.72, -3.53, 'LDN'], ['Truro', 'United Kingdom', 50.26, -5.05, 'LDN'],
    ['Bournemouth', 'United Kingdom', 50.72, -1.88, 'LDN'], ['Portsmouth', 'United Kingdom', 50.82, -1.09, 'LDN'],
    ['Reading', 'United Kingdom', 51.46, -0.97, 'LDN'], ['Chester', 'United Kingdom', 53.19, -2.89, 'LDN'],
    ['Blackpool', 'United Kingdom', 53.82, -3.05, 'LDN'], ['Carlisle', 'United Kingdom', 54.89, -2.93, 'LDN'],
    ['Dundee', 'United Kingdom', 56.46, -2.97, 'LDN'], ['Norwich', 'United Kingdom', 52.63, 1.30, 'LDN'],
    ['Hull', 'United Kingdom', 53.74, -0.33, 'LDN'], ['Stoke-on-Trent', 'United Kingdom', 53.00, -2.18, 'LDN'],
    ['Dublin', 'Ireland', 53.33, -6.25, 'DUB'], ['Cork', 'Ireland', 51.90, -8.47, 'DUB'],
    ['Galway', 'Ireland', 53.27, -9.05, 'DUB'], ['Limerick', 'Ireland', 52.67, -8.63, 'DUB'],
    ['Paris', 'France', 48.86, 2.35, 'PAR'], ['Lyon', 'France', 45.75, 4.85, 'PAR'],
    ['Marseille', 'France', 43.30, 5.37, 'PAR'], ['Nice', 'France', 43.71, 7.26, 'PAR'],
    ['Bordeaux', 'France', 44.84, -0.58, 'PAR'], ['Toulouse', 'France', 43.60, 1.44, 'PAR'],
    ['Berlin', 'Germany', 52.52, 13.41, 'BER'], ['Munich', 'Germany', 48.14, 11.58, 'BER'],
    ['Hamburg', 'Germany', 53.55, 10.00, 'BER'], ['Frankfurt', 'Germany', 50.11, 8.68, 'BER'],
    ['Cologne', 'Germany', 50.94, 6.96, 'BER'], ['Stuttgart', 'Germany', 48.78, 9.18, 'BER'],
    ['Dresden', 'Germany', 51.05, 13.74, 'BER'], ['Leipzig', 'Germany', 51.34, 12.37, 'BER'],
    ['Madrid', 'Spain', 40.42, -3.70, 'MAD'], ['Barcelona', 'Spain', 41.39, 2.15, 'MAD'],
    ['Bilbao', 'Spain', 43.26, -2.93, 'MAD'], ['Seville', 'Spain', 37.39, -5.99, 'MAD'],
    ['Valencia', 'Spain', 39.47, -0.38, 'MAD'],
    ['Rome', 'Italy', 41.90, 12.50, 'ROM'], ['Milan', 'Italy', 45.47, 9.19, 'ROM'],
    ['Naples', 'Italy', 40.84, 14.25, 'ROM'], ['Florence', 'Italy', 43.77, 11.26, 'ROM'],
    ['Amsterdam', 'Netherlands', 52.37, 4.90, 'AMS'], ['Brussels', 'Belgium', 50.85, 4.35, 'BRU'],
    ['Zurich', 'Switzerland', 47.38, 8.54, 'ZRH'], ['Geneva', 'Switzerland', 46.20, 6.14, 'ZRH'],
    ['Vienna', 'Austria', 48.21, 16.37, 'VIE'],
    ['Lisbon', 'Portugal', 38.72, -9.14, 'LIS'], ['Porto', 'Portugal', 41.16, -8.63, 'LIS'],
    ['Faro', 'Portugal', 37.02, -7.93, 'LIS'],
    ['Reykjavik', 'Iceland', 64.13, -21.83, 'REY'], ['Stockholm', 'Sweden', 59.33, 18.07, 'STO'],
    ['Gothenburg', 'Sweden', 57.71, 11.97, 'STO'], ['Oslo', 'Norway', 59.91, 10.75, 'OSL'],
    ['Bergen', 'Norway', 60.39, 5.32, 'OSL'], ['Tromsø', 'Norway', 69.65, 18.96, 'OSL'],
    ['Copenhagen', 'Denmark', 55.68, 12.57, 'CPH'], ['Helsinki', 'Finland', 60.17, 24.94, 'HEL'],
    ['Tampere', 'Finland', 61.50, 23.77, 'HEL'], ['Oulu', 'Finland', 65.01, 25.47, 'HEL'],
    ['Prague', 'Czech Republic', 50.09, 14.42, 'PRG'], ['Warsaw', 'Poland', 52.23, 21.01, 'WAW'],
    ['Kraków', 'Poland', 50.06, 19.94, 'WAW'], ['Budapest', 'Hungary', 47.50, 19.04, 'BUD'],
    ['Bucharest', 'Romania', 44.43, 26.10, 'BUC'], ['Athens', 'Greece', 37.98, 23.73, 'ATH'],
    ['Belgrade', 'Serbia', 44.80, 20.47, 'BER'], ['Kyiv', 'Ukraine', 50.45, 30.52, 'KIE'],
    ['Moscow', 'Russia', 55.75, 37.62, 'MOW'], ['St. Petersburg', 'Russia', 59.93, 30.32, 'MOW'],
    ['Murmansk', 'Russia', 68.97, 33.07, 'MOW'],
    ['Istanbul', 'Turkey', 41.01, 28.95, 'IST'], ['Ankara', 'Turkey', 39.92, 32.85, 'IST'],
    ['Baku', 'Azerbaijan', 40.41, 49.87, 'IST'], ['Tbilisi', 'Georgia', 41.69, 44.83, 'IST'],
    ['Dubai', 'UAE', 25.20, 55.27, 'DXB'], ['Riyadh', 'Saudi Arabia', 24.69, 46.72, 'RIY'],
    ['Tehran', 'Iran', 35.69, 51.39, 'TER'], ['Baghdad', 'Iraq', 33.34, 44.40, 'BAG'],
    ['Cairo', 'Egypt', 30.04, 31.24, 'CAI'], ['Casablanca', 'Morocco', 33.59, -7.62, 'CAS'],
    ['Algiers', 'Algeria', 36.74, 3.06, 'ALG'], ['Lagos', 'Nigeria', 6.45, 3.47, 'LOS'],
    ['Accra', 'Ghana', 5.56, -0.20, 'ACC'], ['Addis Ababa', 'Ethiopia', 9.03, 38.74, 'ADD'],
    ['Nairobi', 'Kenya', -1.29, 36.82, 'NAI'], ['Johannesburg', 'South Africa', -26.20, 28.04, 'JNB'],
    ['Cape Town', 'South Africa', -33.92, 18.42, 'JNB'],
    ['Mumbai', 'India', 19.08, 72.88, 'DEL'], ['Delhi', 'India', 28.66, 77.23, 'DEL'],
    ['Bangalore', 'India', 12.97, 77.56, 'DEL'], ['Chennai', 'India', 13.09, 80.27, 'DEL'],
    ['Kolkata', 'India', 22.57, 88.36, 'DEL'], ['Karachi', 'Pakistan', 24.86, 67.01, 'KAR'],
    ['Bangkok', 'Thailand', 13.75, 100.52, 'BKK'], ['Kuala Lumpur', 'Malaysia', 3.14, 101.69, 'KUL'],
    ['Singapore', 'Singapore', 1.35, 103.82, 'SGP'], ['Jakarta', 'Indonesia', -6.21, 106.85, 'JKT'],
    ['Manila', 'Philippines', 14.60, 120.98, 'MNL'], ['Hong Kong', 'China', 22.30, 114.18, 'HKG'],
    ['Shanghai', 'China', 31.23, 121.47, 'SHA'], ['Beijing', 'China', 39.91, 116.39, 'SHA'],
    ['Guangzhou', 'China', 23.13, 113.26, 'SHA'], ['Chengdu', 'China', 30.66, 104.07, 'SHA'],
    ['Seoul', 'South Korea', 37.57, 126.98, 'SEL'], ['Tokyo', 'Japan', 35.68, 139.69, 'TYO'],
    ['Osaka', 'Japan', 34.69, 135.50, 'TYO'], ['Sapporo', 'Japan', 43.06, 141.35, 'TYO'],
    ['Sydney', 'Australia', -33.87, 151.21, 'SYD'], ['Melbourne', 'Australia', -37.81, 144.96, 'MEL'],
    ['Brisbane', 'Australia', -27.47, 153.02, 'BNE'], ['Perth', 'Australia', -31.95, 115.86, 'PER'],
    ['Adelaide', 'Australia', -34.93, 138.60, 'ADL'], ['Auckland', 'New Zealand', -36.86, 174.77, 'AKL'],
    ['New York', 'USA', 40.71, -74.01, 'NYC'], ['Los Angeles', 'USA', 34.05, -118.24, 'LAX'],
    ['Chicago', 'USA', 41.85, -87.65, 'CHI'], ['Houston', 'USA', 29.76, -95.37, 'CHI'],
    ['Phoenix', 'USA', 33.45, -112.07, 'PHX'], ['Philadelphia', 'USA', 39.95, -75.16, 'NYC'],
    ['Dallas', 'USA', 32.78, -96.80, 'CHI'], ['Seattle', 'USA', 47.61, -122.33, 'LAX'],
    ['Denver', 'USA', 39.74, -104.98, 'DNV'], ['Portland', 'USA', 45.52, -122.68, 'LAX'],
    ['Atlanta', 'USA', 33.75, -84.39, 'NYC'], ['Miami', 'USA', 25.77, -80.19, 'NYC'],
    ['Boston', 'USA', 42.36, -71.06, 'NYC'], ['Washington DC', 'USA', 38.91, -77.04, 'NYC'],
    ['San Francisco', 'USA', 37.78, -122.41, 'LAX'], ['Minneapolis', 'USA', 44.98, -93.27, 'CHI'],
    ['Honolulu', 'USA', 21.31, -157.86, 'HNL'], ['Anchorage', 'USA', 61.22, -149.90, 'ANC'],
    ['Las Vegas', 'USA', 36.17, -115.14, 'LAX'], ['Nashville', 'USA', 36.17, -86.78, 'CHI'],
    ['Toronto', 'Canada', 43.65, -79.38, 'YTZ'], ['Montreal', 'Canada', 45.51, -73.55, 'NYC'],
    ['Vancouver', 'Canada', 49.25, -123.12, 'YVR'], ['Calgary', 'Canada', 51.05, -114.07, 'DNV'],
    ['Edmonton', 'Canada', 53.55, -113.49, 'DNV'], ['Ottawa', 'Canada', 45.42, -75.69, 'NYC'],
    ['Mexico City', 'Mexico', 19.43, -99.13, 'MEX'], ['São Paulo', 'Brazil', -23.55, -46.63, 'SAO'],
    ['Rio de Janeiro', 'Brazil', -22.91, -43.18, 'SAO'], ['Buenos Aires', 'Argentina', -34.61, -58.38, 'BAI'],
    ['Santiago', 'Chile', -33.46, -70.65, 'SCL'], ['Bogotá', 'Colombia', 4.71, -74.07, 'BOG'],
    ['Lima', 'Peru', -12.05, -77.04, 'LIM'],
    ['Colombo', 'Sri Lanka', 6.93, 79.85, 'COL'], ['Dhaka', 'Bangladesh', 23.72, 90.41, 'DHK'],
    ['Kathmandu', 'Nepal', 27.72, 85.32, 'KTM'], ['Yangon', 'Myanmar', 16.87, 96.19, 'RNG'],
    ['Ho Chi Minh City', 'Vietnam', 10.82, 106.63, 'BKK'], ['Hanoi', 'Vietnam', 21.03, 105.85, 'BKK'],
    ['Taipei', 'Taiwan', 25.05, 121.53, 'TPE'],
];

/* ── Pure utility functions ───────────────────────────────────────────────── */

function _scSearchCities(q) {
    if (!q || q.length < 2) return [];
    const clean = q.split(',')[0].trim(), lq = clean.toLowerCase();
    const exact = [], starts = [], contains = [];
    for (const r of _SC_DB) {
        if (r[2] < 0) continue;
        const n = r[0].toLowerCase(), c = r[1].toLowerCase();
        if (n === lq) exact.push(r);
        else if (n.startsWith(lq)) starts.push(r);
        else if (n.includes(lq) || c.includes(lq)) contains.push(r);
    }
    return [...exact, ...starts, ...contains].slice(0, 8);
}

function _scCalcSunTimesUTC(lat, lng, date, zenith = 90.833) {
    const toR = d => d * Math.PI / 180, toD = r => r * 180 / Math.PI;
    const mod = (x, n) => ((x % n) + n) % n;
    const jan1 = Date.UTC(date.getUTCFullYear(), 0, 1);
    const doy = Math.round((Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()) - jan1) / 86400000) + 1;
    const lngH = lng / 15;
    function sun(rising) {
        const approxT = doy + ((rising ? 6 : 18) - lngH) / 24;
        const M = mod(0.9856 * approxT - 3.289, 360);
        const L = mod(M + 1.916 * Math.sin(toR(M)) + 0.02 * Math.sin(toR(2 * M)) + 282.634, 360);
        let RA = mod(toD(Math.atan(0.91764 * Math.tan(toR(L)))), 360);
        const Lq = Math.floor(L / 90) * 90, RAq = Math.floor(RA / 90) * 90;
        RA = mod(RA + (Lq - RAq), 360);
        const sinDec = 0.39782 * Math.sin(toR(L)), cosDec = Math.cos(Math.asin(sinDec));
        const cosH = (Math.cos(toR(zenith)) - sinDec * Math.sin(toR(lat))) / (cosDec * Math.cos(toR(lat)));
        if (cosH > 1 || cosH < -1) return null;
        const H = (rising ? 360 - toD(Math.acos(cosH)) : toD(Math.acos(cosH))) / 15;
        const T = H + RA / 15 - 0.06571 * approxT - 6.622;
        return mod(T - lngH, 24);
    }
    return { rise: sun(true), set: sun(false) };
}

function _scCalcTwilightUTC(lat, lng, date) {
    return _scCalcSunTimesUTC(lat, lng, date, 96);
}

function _scUtcHToLocal(utcH, tz, date) {
    if (utcH === null) return null;
    try {
        const d = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), Math.floor(utcH), Math.round((utcH % 1) * 60), 0));
        const parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(d);
        const h = parseInt(parts.find(p => p.type === 'hour').value);
        const m = parseInt(parts.find(p => p.type === 'minute').value);
        return h + m / 60;
    } catch { return null; }
}

function _scSleepDur(b, w) { const d = w - b; return d <= 0 ? d + 24 : d; }

function _scOverlapSegs(b, w, r, s) {
    const e = w <= b ? w + 24 : w, segs = [];
    const a = Math.max(b, r), ee = Math.min(e, s);
    if (ee > a) segs.push({ s: a, d: ee - a });
    if (e > 24) { const c = Math.max(0, r), dd = Math.min(w, s); if (dd > c) segs.push({ s: c, d: dd - c }); }
    return segs;
}

function _scTotalOverlap(b, w, r, s) { return _scOverlapSegs(b, w, r, s).reduce((sum, o) => sum + o.d, 0); }

function _scParseT(str) { const [h, m] = str.split(':').map(Number); return h + m / 60; }

function _scFmtH(h) {
    const tot = Math.round(h * 60), hr = Math.floor(tot / 60), mn = tot % 60;
    return mn === 0 ? `${hr}h` : `${hr}h ${mn}m`;
}

function _scFmtHLong(h) {
    const tot = Math.round(h * 60), hr = Math.floor(tot / 60), mn = tot % 60;
    if (hr === 0) return `${mn} minute${mn !== 1 ? 's' : ''}`;
    return mn === 0 ? `${hr} hour${hr !== 1 ? 's' : ''}` : `${hr} hr ${mn} min`;
}

function _scFmtT(h) {
    const tot = Math.round(h * 60), hr = Math.floor(tot / 60) % 24, mn = tot % 60;
    const ap = hr >= 12 ? 'PM' : 'AM', dh = hr % 12 || 12;
    return `${dh}:${String(mn).padStart(2, '0')} ${ap}`;
}

function _scIsPolarDay(lat) {
    const doy = 172;
    const decl = 23.45 * Math.sin((360 / 365 * (doy - 81)) * Math.PI / 180);
    return Math.abs(lat) > (90 - decl);
}

const _SC_SOLSTICE = _scSummerSolstice(new Date().getUTCFullYear());

function _scGetCityTwilightTimes(lat, lng, tzKey) {
    const tz = _SC_TZ[tzKey];
    const { rise: dawnUTC, set: duskUTC } = _scCalcTwilightUTC(lat, lng, _SC_SOLSTICE);
    let dawnH = _scUtcHToLocal(dawnUTC, tz, _SC_SOLSTICE);
    let duskH = _scUtcHToLocal(duskUTC, tz, _SC_SOLSTICE);
    if (dawnH !== null && duskH !== null && duskH < dawnH) duskH += 24;
    return { dawnH, duskH, dawnUTC, duskUTC };
}

function _scGetCityTwilightOverlap(lat, lng, tzKey, bedH, wakeH) {
    if (_scIsPolarDay(lat)) return _scSleepDur(bedH, wakeH);
    const { dawnH, duskH, dawnUTC } = _scGetCityTwilightTimes(lat, lng, tzKey);
    if (dawnUTC === null) return _scSleepDur(bedH, wakeH);
    return _scTotalOverlap(bedH, wakeH, dawnH, duskH);
}

function _scHaversineKm(lat1, lng1, lat2, lng2) {
    const R = 6371, toR = d => d * Math.PI / 180;
    const dLat = toR(lat2 - lat1), dLng = toR(lng2 - lng1);
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(toR(lat1)) * Math.cos(toR(lat2)) * Math.sin(dLng / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

function _scGetContinent(lat, lng) {
    if (lng < -30) { return lat > 15 ? 'north-america' : 'south-america'; }
    if (lng > 100 && lat < -10) return 'oceania';
    if (lat > 35 && lng > -15 && lng < 45) return 'europe';
    if (lat > -38 && lat < 38 && lng > -18 && lng < 55) return 'africa';
    return 'asia';
}

function _scFindSameCities(bedH, wakeH, userOv, userRH, userSH, userLat, userLng, excludeName, userContinent, userNoDawn) {
    const normUserSH = userSH === null ? null : ((userSH % 24) + 24) % 24;
    const sdH = _scSleepDur(bedH, wakeH);
    const allNorth = _SC_DB
        .filter(c => c[0] !== excludeName && c[2] > 0)
        .map(c => {
            const tw = _scGetCityTwilightTimes(c[2], c[3], c[4]);
            const noDawn = _scIsPolarDay(c[2]) || tw.dawnUTC === null;
            const ov = noDawn ? sdH : _scGetCityTwilightOverlap(c[2], c[3], c[4], bedH, wakeH);
            const normDusk = tw.duskH === null ? null : ((tw.duskH % 24) + 24) % 24;
            const isHighLatUser = userLat > 58;
            const ovDiff = (isHighLatUser && noDawn) ? 0 : Math.abs(ov - userOv);
            const srDiff = (isHighLatUser && noDawn) ? 0 : (userRH === null || tw.dawnH === null ? 99 : Math.min(Math.abs(tw.dawnH - userRH), 24 - Math.abs(tw.dawnH - userRH)));
            const ssDiff = (isHighLatUser && noDawn) ? 0 : (normUserSH === null || normDusk === null ? 99 : Math.min(Math.abs(normDusk - normUserSH), 24 - Math.abs(normDusk - normUserSH)));
            const dist = _scHaversineKm(userLat, userLng, c[2], c[3]);
            const continent = _scGetContinent(c[2], c[3]);
            return { name: c[0], country: c[1], lat: c[2], lng: c[3], tz: c[4], ov, noDawn, ovDiff, srDiff, ssDiff, dist, continent };
        });

    if (userNoDawn) {
        const polarPool = allNorth.filter(c => c.noDawn);
        const crossCont = polarPool.filter(c => c.continent !== userContinent && c.dist > 500);
        const byCont = new Map();
        for (const c of crossCont) { if (!byCont.has(c.continent)) byCont.set(c.continent, c); }
        const reps = [...byCont.values()].slice(0, 2);
        if (reps.length >= 2) return reps;
        const fallback = polarPool.filter(c => c.dist > 100).sort((a, b) => b.lat - a.lat);
        const combined = [...reps];
        for (const c of fallback) {
            if (combined.length >= 2) break;
            if (!combined.some(x => x.name === c.name)) combined.push(c);
        }
        return combined;
    }

    const candidates = allNorth
        .filter(c => c.continent !== userContinent && c.dist > 500)
        .sort((a, b) => (a.ovDiff * 2 + a.ssDiff + a.srDiff * 0.5) - (b.ovDiff * 2 + b.ssDiff + b.srDiff * 0.5));

    for (const OV of [0.25, 0.5, 0.75, 1.0, 99]) {
        const pool = OV === 99 ? candidates : candidates.filter(c => c.ovDiff < OV);
        const byContinent = new Map();
        for (const c of pool) { if (!byContinent.has(c.continent)) byContinent.set(c.continent, c); }
        const reps = [...byContinent.values()].sort((a, b) => (a.ovDiff * 2 + a.ssDiff + a.srDiff * 0.5) - (b.ovDiff * 2 + b.ssDiff + b.srDiff * 0.5));
        if (reps.length >= 2) return reps.slice(0, 2);
    }
    return [];
}

function _scFmtTimePicker(hhmm) {
    const [h, m] = hhmm.split(':').map(Number);
    const ap = h >= 12 ? 'PM' : 'AM', dh = h % 12 || 12;
    return `${dh}:${String(m).padStart(2, '0')} ${ap}`;
}

/* ── Clock SVG builder ────────────────────────────────────────────────────── */
function _scBuildClock(svgEl, cx, cy, outerR, trackR, trackW, bedH, wakeH, rH, sH, mini = false, polar = null, pct = 0, colors = {}) {
    const {
        accent = '#FF5859', sunrise = '#f5c518',
        sleep = '#818cf8', sleepLight = '#a5b4fc',
    } = colors;

    const NS = 'http://www.w3.org/2000/svg';
    svgEl.innerHTML = '';
    const el = (tag, attrs, par) => {
        const n = document.createElementNS(NS, tag);
        for (const [k, v] of Object.entries(attrs)) n.setAttribute(k, v);
        (par || svgEl).appendChild(n);
        return n;
    };
    const TAU = Math.PI * 2;
    const h2a = h => (h / 24) * TAU - Math.PI / 2;
    const pt = (cx, cy, r, a) => ({ x: cx + r * Math.cos(a), y: cy + r * Math.sin(a) });
    function arcD(cx, cy, r, sH, dH) {
        if (dH >= 24) return `M ${cx} ${cy - r} A ${r} ${r} 0 1 1 ${cx - 0.001} ${cy - r} Z`;
        const s = pt(cx, cy, r, h2a(sH)), e = pt(cx, cy, r, h2a(sH + dH));
        return `M ${s.x} ${s.y} A ${r} ${r} 0 ${dH > 12 ? 1 : 0} 1 ${e.x} ${e.y}`;
    }

    el('circle', { cx, cy, r: outerR, fill: 'var(--color-background)', stroke: 'var(--color-border)', 'stroke-width': '1' });
    for (let h = 0; h < 24; h += (mini ? 6 : 1)) {
        const a = h2a(h), i = pt(cx, cy, outerR - 8, a), o = pt(cx, cy, outerR - 2, a);
        el('line', { x1: i.x, y1: i.y, x2: o.x, y2: o.y, stroke: 'var(--color-border)', 'stroke-width': h % 6 === 0 ? '2' : '1' });
    }

    if (polar !== 'night') {
        const dayDur = sH - rH;
        el('path', { d: arcD(cx, cy, trackR, rH, dayDur), stroke: sunrise, 'stroke-width': trackW, fill: 'none', 'stroke-linecap': 'butt', opacity: '0.25' });
        const sd = _scSleepDur(bedH, wakeH);
        for (const seg of _scOverlapSegs(bedH, wakeH, rH, sH)) {
            el('path', { d: arcD(cx, cy, trackR, seg.s, seg.d), stroke: accent, 'stroke-width': trackW, fill: 'none', 'stroke-linecap': 'butt' });
        }
        for (const [h, col] of [[rH, sunrise], [sH, sunrise]]) {
            const p = pt(cx, cy, trackR, h2a(h));
            el('circle', { cx: p.x, cy: p.y, r: '5', fill: col });
        }
    }

    el('path', { d: arcD(cx, cy, trackR, bedH, _scSleepDur(bedH, wakeH)), stroke: sleep, 'stroke-width': trackW / 2, fill: 'none', 'stroke-linecap': 'butt', opacity: '0.4' });
    for (const [h, col] of [[bedH, sleep], [wakeH, sleepLight]]) {
        const p = pt(cx, cy, trackR, h2a(h));
        el('circle', { cx: p.x, cy: p.y, r: '5', fill: col });
    }

    if (!mini) {
        for (const [h, lbl, anchor] of [[0, '12 AM', 'middle'], [6, '6 AM', 'start'], [12, '12 PM', 'middle'], [18, '6 PM', 'end']]) {
            const p = pt(cx, cy, outerR + 20, h2a(h));
            el('text', { x: p.x, y: p.y, 'text-anchor': anchor, 'dominant-baseline': 'middle', fill: 'var(--color-text)', 'font-size': '11', 'font-family': 'inherit' }).textContent = lbl;
        }
    }

    const dispPct = polar === 'day' ? 100 : polar === 'night' ? 0 : pct;
    const pctCol = dispPct > 0 ? accent : polar === 'night' ? 'var(--color-text)' : 'var(--sc-success)';
    el('text', { x: cx, y: cy - 12, 'text-anchor': 'middle', fill: pctCol, 'font-size': mini ? '18' : '28', 'font-weight': '700', 'font-family': 'inherit' }).textContent =
        polar === 'night' ? '0%' : polar === 'day' ? '100%' : `${pct}%`;
    el('text', { x: cx, y: cy + 14, 'text-anchor': 'middle', fill: 'var(--color-text)', 'font-size': '11', 'font-family': 'inherit' }).textContent =
        polar === 'night' ? 'No disruption' : polar === 'day' ? 'Midnight sun' : 'in daylight';
}

/* ── Custom Element ───────────────────────────────────────────────────────── */
class SummerCalculator extends HTMLElement {
    connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this._init();
    }

    _getColors() {
        const cs = getComputedStyle(this);
        return {
            accent: cs.getPropertyValue('--color-accent').trim() || '#FF5859',
            sunrise: cs.getPropertyValue('--sc-sunrise').trim() || '#f5c518',
            sleep: cs.getPropertyValue('--sc-sleep').trim() || '#818cf8',
            sleepLight: cs.getPropertyValue('--sc-sleep-light').trim() || '#a5b4fc',
            success: cs.getPropertyValue('--sc-success').trim() || '#34d399',
        };
    }

    _init() {
        const root = this;
        this._selectedCity = null;
        this._acResults = [];
        this._acHighlight = -1;

        /* Solstice badge */
        const badge = root.querySelector('#sc-solstice-badge');
        if (badge) {
            const d = _SC_SOLSTICE;
            const label = d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
            badge.textContent = `\u2600\uFE0F ${label}`;
            badge.style.visibility = 'visible';
        }

        /* Time picker buttons */
        root.querySelectorAll('.sc-tp-btn[data-adjust]').forEach(btn => {
            btn.addEventListener('click', () => {
                this._adjustTime(btn.dataset.adjust, parseInt(btn.dataset.delta));
            });
        });

        /* Time picker wheel */
        ['bedtime', 'waketime'].forEach(id => {
            const picker = root.querySelector(`#sc-${id}-picker`);
            if (!picker) return;
            picker.addEventListener('wheel', e => {
                e.preventDefault();
                this._adjustTime(id, e.deltaY > 0 ? 30 : -30);
            }, { passive: false });
        });

        /* Autocomplete */
        const locInput = root.querySelector('#sc-locInput');
        const acList = root.querySelector('#sc-acList');

        locInput.addEventListener('input', () => {
            this._selectedCity = null;
            const q = locInput.value.trim();
            this._acResults = _scSearchCities(q);
            this._acHighlight = -1;
            this._renderAcList(locInput, acList);
        });

        locInput.addEventListener('keydown', e => {
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                this._acHighlight = Math.min(this._acHighlight + 1, this._acResults.length - 1);
                this._updateAcHighlight(locInput, acList);
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                this._acHighlight = Math.max(this._acHighlight - 1, -1);
                this._updateAcHighlight(locInput, acList);
            } else if (e.key === 'Enter') {
                e.preventDefault();
                const idx = this._acHighlight >= 0 ? this._acHighlight : 0;
                if (this._acResults[idx]) this._selectCity(this._acResults[idx], locInput, acList);
            } else if (e.key === 'Escape') {
                this._closeAcList(locInput, acList);
            }
        });

        locInput.addEventListener('blur', () => {
            setTimeout(() => this._closeAcList(locInput, acList), 150);
        });

        acList.addEventListener('mousedown', e => {
            const item = e.target.closest('[role="option"]');
            if (!item) return;
            e.preventDefault();
            const i = parseInt(item.dataset.i);
            if (this._acResults[i]) this._selectCity(this._acResults[i], locInput, acList);
        });

        this._setupInsightsAccordion();

        /* Analyze button */
        root.querySelector('#sc-analyzeBtn').addEventListener('click', () => this._run());

        /* Tooltip toggles */
        ['sc-polarTipWrap', 'sc-twTipWrap'].forEach(wrapId => {
            const wrap = root.querySelector(`#${wrapId}`);
            if (!wrap) return;
            const btn = wrap.querySelector('button');
            btn.addEventListener('click', e => {
                e.stopPropagation();
                const isActive = wrap.classList.toggle('sc-active');
                btn.setAttribute('aria-expanded', String(isActive));
            });
        });

        document.addEventListener('click', e => {
            if (!root.contains(e.target)) {
                root.querySelectorAll('.sc-tw-tip-wrap.sc-active').forEach(w => {
                    w.classList.remove('sc-active');
                    const b = w.querySelector('button');
                    if (b) b.setAttribute('aria-expanded', 'false');
                });
            }
        });
    }

    _setupInsightsAccordion() {
        const toggle = this.querySelector('#sc-insightsToggle');
        const panel = this.querySelector('#sc-insightsPanel');
        if (!toggle || !panel) return;

        if (!toggle.dataset.scAccordionBound) {
            toggle.addEventListener('click', () => {
                const isOpen = toggle.getAttribute('aria-expanded') === 'true';
                this._setInsightsAccordionOpen(!isOpen);
            });
            toggle.dataset.scAccordionBound = 'true';
        }

        this._setInsightsAccordionOpen(false);
    }

    _setInsightsAccordionOpen(isOpen) {
        const item = this.querySelector('#sc-insightsItem');
        const toggle = this.querySelector('#sc-insightsToggle');
        const panel = this.querySelector('#sc-insightsPanel');
        if (!item || !toggle || !panel) return;

        item.classList.toggle('is-open', isOpen);
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

        if (isOpen) {
            panel.removeAttribute('inert');
            this._setInsightsControlsTabbable(true);
            requestAnimationFrame(() => this._syncInsightTrackHeight());
        } else {
            panel.setAttribute('inert', '');
            this._setInsightsControlsTabbable(false);
        }
    }

    _setInsightsControlsTabbable(isTabbable) {
        this.querySelectorAll('#sc-carouselPrev, #sc-carouselNext, #sc-carouselDots button').forEach(control => {
            if (isTabbable) {
                control.removeAttribute('tabindex');
            } else {
                control.setAttribute('tabindex', '-1');
            }
        });
    }

    _syncInsightTrackHeight() {
        const panel = this.querySelector('#sc-insightsPanel');
        const trackEl = this.querySelector('.sc-carousel-track');
        if (!panel || !trackEl || panel.getAttribute('aria-hidden') === 'true') return;

        const activeCard = this.querySelector('.sc-insight-card[aria-hidden="false"]') || this.querySelector('.sc-insight-card');
        if (!activeCard) return;

        const nextHeight = activeCard.offsetHeight;
        if (nextHeight > 0) {
            trackEl.style.height = `${nextHeight}px`;
        }
    }

    _adjustTime(id, deltaMin) {
        const inp = this.querySelector(`#sc-${id}`);
        let [h, m] = inp.value.split(':').map(Number);
        let tot = h * 60 + m + deltaMin;
        tot = ((tot % 1440) + 1440) % 1440;
        h = Math.floor(tot / 60); m = tot % 60;
        const val = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
        inp.value = val;
        const disp = this.querySelector(`#sc-${id}-disp`);
        disp.textContent = _scFmtTimePicker(val);
        disp.setAttribute('aria-label', `Current ${id === 'bedtime' ? 'bed' : 'wake'} time: ${_scFmtTimePicker(val)}`);
    }

    _renderAcList(locInput, acList) {
        if (!this._acResults.length) {
            this._closeAcList(locInput, acList);
            return;
        }
        acList.innerHTML = this._acResults.map((r, i) => `
      <li class="sc-ac-item"
          role="option"
          id="sc-ac-item-${i}"
          data-i="${i}"
          aria-selected="false">
        <span class="sc-ac-city">${r[0]}</span>
        <span class="sc-ac-country">${r[1]}</span>
      </li>`).join('');
        acList.removeAttribute('hidden');
        locInput.setAttribute('aria-expanded', 'true');
    }

    _updateAcHighlight(locInput, acList) {
        acList.querySelectorAll('[role="option"]').forEach((item, i) => {
            const selected = i === this._acHighlight;
            item.setAttribute('aria-selected', String(selected));
        });
        if (this._acHighlight >= 0) {
            locInput.setAttribute('aria-activedescendant', `sc-ac-item-${this._acHighlight}`);
        } else {
            locInput.removeAttribute('aria-activedescendant');
        }
    }

    _selectCity(row, locInput, acList) {
        this._selectedCity = { name: row[0], country: row[1], lat: row[2], lng: row[3], tz: _SC_TZ[row[4]] };
        locInput.value = `${row[0]}, ${row[1]}`;
        this._closeAcList(locInput, acList);
    }

    _closeAcList(locInput, acList) {
        acList.innerHTML = '';
        acList.setAttribute('hidden', '');
        locInput.setAttribute('aria-expanded', 'false');
        locInput.removeAttribute('aria-activedescendant');
        this._acHighlight = -1;
    }

    _run() {
        const root = this;
        const bedtime = root.querySelector('#sc-bedtime').value;
        const waketime = root.querySelector('#sc-waketime').value;
        const locInput = root.querySelector('#sc-locInput');
        const acList = root.querySelector('#sc-acList');

        if (!this._selectedCity) {
            const q = locInput.value.trim();
            if (!q) { this._showErr('Please enter a city name.'); return; }
            const m = _scSearchCities(q);
            if (!m.length) { this._showErr(`No city found matching "${q.split(',')[0].trim()}". Try a nearby major city.`); return; }
            this._selectCity(m[0], locInput, acList);
        }
        if (!bedtime || !waketime) { this._showErr('Please fill in bed time and wake time.'); return; }
        this._hideErr();

        const { lat, lng, tz, name } = this._selectedCity;
        const bedH = _scParseT(bedtime), wakeH = _scParseT(waketime);
        const sdH = _scSleepDur(bedH, wakeH);

        let polar = null, rH, sH;
        if (_scIsPolarDay(lat)) {
            polar = 'day'; rH = 0; sH = 24;
        } else {
            const { rise: riseUTC, set: setUTC } = _scCalcSunTimesUTC(lat, lng, _SC_SOLSTICE);
            if (riseUTC === null) { polar = 'night'; rH = 6; sH = 20; }
            else {
                rH = _scUtcHToLocal(riseUTC, tz, _SC_SOLSTICE);
                sH = _scUtcHToLocal(setUTC, tz, _SC_SOLSTICE);
                if (rH !== null && sH !== null && sH < rH) sH += 24;
            }
        }

        let dawnH = null, duskH = null;
        if (polar !== 'day' && polar !== 'night') {
            const { rise: dawnUTC, set: duskUTC } = _scCalcTwilightUTC(lat, lng, _SC_SOLSTICE);
            dawnH = _scUtcHToLocal(dawnUTC, tz, _SC_SOLSTICE);
            duskH = _scUtcHToLocal(duskUTC, tz, _SC_SOLSTICE);
            if (dawnH !== null && duskH !== null && duskH < dawnH) duskH += 24;
        }

        const perpetualTwilight = polar === null && dawnH === null;
        const effectiveDawn = (polar === 'day' || perpetualTwilight) ? 0 : (dawnH !== null ? dawnH : rH);
        const effectiveDusk = (polar === 'day' || perpetualTwilight) ? 24 : (duskH !== null ? duskH : sH);
        const ovH = polar === 'night' ? 0 : ((polar === 'day' || perpetualTwilight) ? sdH : _scTotalOverlap(bedH, wakeH, effectiveDawn, effectiveDusk));
        const pct = sdH > 0 ? Math.round((ovH / sdH) * 100) : 0;

        const colors = this._getColors();

        _scBuildClock(
            root.querySelector('#mainClock'), 210, 210, 175, 138, 30,
            bedH, wakeH,
            (polar === 'day' || perpetualTwilight) ? 0 : effectiveDawn,
            (polar === 'day' || perpetualTwilight) ? 24 : effectiveDusk,
            false,
            polar === 'night' ? 'night' : (polar === 'day' || perpetualTwilight) ? 'day' : null,
            pct,
            colors
        );

        root.querySelector('#sc-sumEyebrow').textContent = `SUMMER SOLSTICE IN ${name.toUpperCase()}`;

        const dispSH = sH >= 24 ? sH - 24 : sH;
        const dispDusk = duskH != null ? (duskH >= 24 ? duskH - 24 : duskH) : null;

        root.querySelector('#sc-sumTitle').textContent =
            polar === 'day' ? `The sun never sets in ${name} on June 21`
                : perpetualTwilight ? `The sky never fully darkens in ${name} on June 21`
                    : polar === 'night' ? `No sunlight disruption in ${name} on June 21`
                        : pct === 0 ? `Your sleep is fully protected from daylight`
                            : `${_scFmtHLong(ovH)} of your sleep will be in daylight`;

        root.querySelector('#sc-sumDesc').textContent =
            polar === 'day' ? `Midnight sun: your entire sleep window is in daylight.`
                : perpetualTwilight ? `Civil twilight never ends – the sky stays light all night.`
                    : polar === 'night' ? `The sun never rises – no disruption at all.`
                        : pct === 0 ? `First light arrives after you wake up. Lucky you.`
                            : `Your sleep overlaps with ${_scFmtHLong(ovH)} of daylight.`;

        root.querySelector('#sc-sSunset').textContent = polar === 'day' ? '—' : (sH ? _scFmtT(dispSH) : '—');
        root.querySelector('#sc-sLastLight').textContent = polar === 'day' ? '—' : (duskH ? _scFmtT(dispDusk) : '—');
        root.querySelector('#sc-sFirstLight').textContent = polar === 'day' ? '—' : (dawnH ? _scFmtT(dawnH) : '—');
        root.querySelector('#sc-sSunrise').textContent = polar === 'day' ? '—' : (rH ? _scFmtT(rH) : '—');

        /* Polar note tooltip */
        const polarNoteEl = root.querySelector('#sc-polarNote');
        const polarTipText = root.querySelector('#sc-polarTipText');
        if (!polar && dawnH === null) {
            polarTipText.textContent = `Why there's no first or last light in ${name}`;
            polarNoteEl.style.display = 'block';
        } else {
            polarNoteEl.style.display = 'none';
        }

        /* Twilight extension note */
        const twilightNoteEl = root.querySelector('#sc-twilightNote');
        const twTipText = root.querySelector('#sc-twTipText');
        if (!polar && dawnH !== null && duskH !== null && rH !== null && sH !== null) {
            const twExtMins = Math.round(((duskH - sH) + (rH - dawnH)) * 60);
            if (twExtMins > 0) {
                twTipText.textContent = `Why there's light before sunrise and after sunset in ${name}`;
                twilightNoteEl.style.display = 'block';
            } else {
                twilightNoteEl.style.display = 'none';
            }
        } else {
            twilightNoteEl.style.display = 'none';
        }

        /* World stat */
        if (ovH > 0) {
            const betterCount = _SC_DB.filter(c => _scGetCityTwilightOverlap(c[2], c[3], c[4], bedH, wakeH) < ovH - 0.05).length;
            const worldPct = Math.round(betterCount / _SC_DB.length * 100);
            root.querySelector('#sc-sumDesc').textContent = `That's more light disruption than ${worldPct}% of people on Earth.`;
        }

        /* Reveal results */
        const resultsEl = root.querySelector('#sc-results');
        resultsEl.classList.add('sc-visible');
        setTimeout(() => {
            const top = resultsEl.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top, behavior: 'smooth' });
        }, 60);

        /* Twin cities */
        const userContinent = _scGetContinent(lat, lng);
        const userNoDawn = polar === 'day' || dawnH === null;
        const twinC = _scFindSameCities(bedH, wakeH, ovH, effectiveDawn, effectiveDusk, lat, lng, name, userContinent, userNoDawn);
        this._renderTwinCities(twinC, userNoDawn);

        /* Insights */
        this._buildInsightCards({ name, bedH, wakeH, dawnH, duskH, polar, ovH, rH, sH });
    }

    _renderTwinCities(cities, noDawn) {
        const root = this;
        const section = root.querySelector('#sc-twinSection');
        const grid = root.querySelector('#sc-twinGrid');
        if (!cities || !cities.length) { section.style.display = 'none'; return; }
        section.style.display = 'block';
        grid.innerHTML = '';
        for (const c of cities) {
            const li = document.createElement('li');
            li.className = 'sc-twin-chip';
            const stat = noDawn ? 'Never fully dark' : `${_scFmtH(c.ov)} in daylight`;
            li.innerHTML = `
        <span class="sc-twin-city-name">${c.name}</span>
        <span class="sc-twin-city-country">${c.country}</span>
        <span class="sc-twin-city-stat">${stat}</span>`;
            grid.appendChild(li);
        }
    }

    _buildInsightCards({ name, bedH, wakeH, dawnH, duskH, polar, ovH, rH, sH }) {
        const duskDisp = duskH !== null ? (duskH >= 24 ? duskH - 24 : duskH) : null;
        const bt = _scFmtT(bedH), wt = _scFmtT(wakeH);
        const ll = duskDisp !== null ? _scFmtT(duskDisp) : '—';
        const fl = dawnH !== null ? _scFmtT(dawnH) : '—';

        const bedH24 = bedH < 8 ? bedH + 24 : bedH;
        const gapLastToBed = duskH !== null ? bedH24 - duskH : null;
        const gapDawnToWake = dawnH !== null ? wakeH - dawnH : null;
        const gDW = (gapDawnToWake !== null && gapDawnToWake > 0) ? _scFmtHLong(gapDawnToWake) : '—';
        const darkMinutes = gapLastToBed !== null ? Math.round(Math.abs(gapLastToBed) * 60) : null;
        const dimDownTime = _scFmtT(bedH - 1.5);
        const newBedTime = _scFmtT(bedH - 0.75);
        const newWakeTime = _scFmtT(wakeH - 0.75);

        const p1 = gapLastToBed !== null && gapLastToBed < 1.5;
        const pe = gapDawnToWake !== null && gapDawnToWake > 1.0;
        const p5 = p1 && pe;

        let cards = [];

        if (polar === 'day' || dawnH === null) {
            cards = [
                {
                    heading: "The sky never signals it's time to sleep",
                    body: `In ${name}, it's still light outside when you get into bed at ${bt}. Your brain relies on falling light levels as the cue to start producing melatonin. When that signal never comes, melatonin is delayed – making it harder to fall asleep even if you feel exhausted.`,
                    fixBold: 'Avoid light in the hours before bed.',
                    fixRest: ` Come inside well before ${bt} and close the curtains. Use a sleep mask once you're in bed to block any remaining light. In summer in ${name}, darkness isn't something that happens to you – it's something you have to build.`,
                },
                {
                    heading: 'Morning light comes way before you\'re ready for it',
                    body: `When you wake up in a light room, melatonin dips and cortisol rises. This tells your body it's time to wake up even if it's only 3 AM – making it harder to get back to sleep.`,
                    fixBold: 'Get outside as soon as you\'re awake.',
                    fixRest: ` 10–15 minutes of outdoor light at ${wt} each day strengthens your circadian rhythm, signalling to your body when the day actually starts.`,
                },
            ];
        } else if (ovH <= 0.017) {
            cards = [
                {
                    heading: 'Your sleep schedule is naturally protected – for now',
                    body: `You wake up at ${wt}, which is before first light arrives at ${fl}. No summer light is reaching you during sleep. But it's fragile: even a small shift in bedtime or wake time could push you into the disruption window.`,
                    fixBold: 'Protect the routine that\'s protecting you.',
                    fixRest: ` Avoid letting your ${bt} bedtime drift later as evenings get lighter. That could bring ${fl} right into your sleep window.`,
                },
                {
                    heading: 'Evening light is still working against your body clock',
                    body: `Even though your sleep is protected, last light in ${name} doesn't arrive until ${ll}. A burst of bright light that late mimics a morning signal to your brain, suppressing melatonin production.`,
                    fixBold: 'Avoid light in the hours before bed.',
                    fixRest: ` Come inside before ${ll} and close the curtains. If you're outside in the evening, wear sunglasses or blue-light-blocking glasses.`,
                },
            ];
        } else {
            const peShiftRaw = gapDawnToWake !== null ? Math.max(0.5, Math.min(2, gapDawnToWake - 0.25)) : 0.75;
            const peShift = Math.round(peShiftRaw * 4) / 4;
            const peNewBed = _scFmtT(bedH - peShift);
            const peNewWake = _scFmtT(wakeH - peShift);

            const all = [
                {
                    id: 'P5', score: p5 ? 9 : -1, card: {
                        heading: 'Your body clock is being squeezed from both ends',
                        body: `In ${name}, you have ${_scFmtHLong(ovH)} of light disruption while you sleep – hitting you at both ends. Melatonin is delayed at night and cortisol is triggered too early in the morning.`,
                        fixBold: 'Take control at both ends.',
                        fixRest: ` Come inside 60–90 minutes before bed and close all the curtains. Use a sleep mask from ${bt} through ${wt}. Without both, you're only solving half the problem.`,
                    }
                },
                {
                    id: 'PE', score: pe ? 8 : -1, card: {
                        heading: 'Early light is cutting your sleep short – and it shows',
                        body: `First light in ${name} arrives at ${fl} – ${gDW} before your ${wt} alarm. When light enters your sleep in those final hours, it cuts your REM sleep short, making it harder to focus the next day.`,
                        fixBold: 'Protect the final hours of your sleep.',
                        fixRest: ` A sleep mask removes light entirely. If your schedule allows, shift your sleep window ${_scFmtHLong(peShift)} earlier: bed at ${peNewBed}, wake at ${peNewWake}.`,
                    }
                },
                {
                    id: 'P1', score: p1 ? 8 : -1, card: {
                        heading: 'Your melatonin window is too short',
                        body: (gapLastToBed !== null && gapLastToBed <= 0)
                            ? `Your body needs around 90 minutes of falling light (dim light melatonin onset) for high-quality sleep, but right now it's getting none.`
                            : `Your body needs around 90 minutes of dim light melatonin onset for high-quality sleep, but you're only getting ${darkMinutes} minutes.`,
                        fixBold: `Come inside and start dimming at ${dimDownTime}.`,
                        fixRest: ` Close the curtains and bring lights and screens down gradually. Your brain needs the transition, not just the destination.`,
                    }
                },
                {
                    id: 'PC', score: 5, card: {
                        heading: 'Watch out for social jetlag',
                        body: `During bright summer evenings, you naturally stay out later. Going to bed 1–2 hours after your usual bedtime is like jetlag for your body clock.`,
                        fixBold: 'Stay consistent, even at weekends.',
                        fixRest: ` Go to bed and wake up within the same 30-minute window each day. If you go to bed later, keep your usual wake time – sleeping in only makes the next night harder.`,
                    }
                },
            ];
            cards = all.filter(c => c.score > 0).sort((a, b) => b.score - a.score).map(c => c.card);
        }

        this._renderInsights(cards);
    }

    _renderInsights(cards) {
        const root = this;
        const wrap = root.querySelector('#sc-insightsWrap');
        const slidesEl = root.querySelector('#sc-carouselSlides');
        const dotsEl = root.querySelector('#sc-carouselDots');
        const counterEl = root.querySelector('#sc-carouselCounter');
        const prevBtn = root.querySelector('#sc-carouselPrev');
        const nextBtn = root.querySelector('#sc-carouselNext');

        if (!cards || !cards.length) {
            wrap.style.display = 'none';
            this._setInsightsAccordionOpen(false);
            return;
        }

        wrap.style.display = 'block';
        this._setupInsightsAccordion();

        let current = 0;
        const trackEl = slidesEl.parentElement;

        slidesEl.innerHTML = '';
        cards.forEach((c, idx) => {
            const div = document.createElement('div');
            div.className = 'sc-insight-card';
            div.setAttribute('role', 'tabpanel');
            div.setAttribute('id', `sc-insight-card-${idx}`);
            div.setAttribute('aria-labelledby', `sc-dot-${idx}`);
            div.setAttribute('aria-hidden', idx !== 0 ? 'true' : 'false');
            div.innerHTML = `
        <div>
          <h4 class="sc-card-heading">${c.heading}</h4>
          <p class="sc-card-body">${c.body}</p>
        </div>
        <div class="sc-card-fix">
          <p class="sc-card-fix-label">The fix</p>
          <p class="sc-card-fix-text"><strong>${c.fixBold}</strong>${c.fixRest}</p>
        </div>`;
            slidesEl.appendChild(div);
        });

        dotsEl.innerHTML = '';
        cards.forEach((_, i) => {
            const dot = document.createElement('button');
            dot.className = 'sc-c-dot' + (i === 0 ? ' sc-active' : '');
            dot.setAttribute('type', 'button');
            dot.setAttribute('role', 'tab');
            dot.setAttribute('id', `sc-dot-${i}`);
            dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
            dot.setAttribute('aria-controls', `sc-insight-card-${i}`);
            dot.setAttribute('aria-label', `Insight ${i + 1} of ${cards.length}`);
            dot.setAttribute('tabindex', i === 0 ? '0' : '-1');
            dot.addEventListener('click', () => goTo(i, false));
            dotsEl.appendChild(dot);
        });

        const goTo = (idx, focusActiveDot) => {
            current = Math.max(0, Math.min(idx, cards.length - 1));
            slidesEl.style.transform = `translateX(-${current * 100}%)`;
            dotsEl.querySelectorAll('.sc-c-dot').forEach((d, i) => {
                d.classList.toggle('sc-active', i === current);
                d.setAttribute('aria-selected', i === current ? 'true' : 'false');
                d.setAttribute('tabindex', i === current ? '0' : '-1');
            });
            slidesEl.querySelectorAll('.sc-insight-card').forEach((card, i) => {
                card.setAttribute('aria-hidden', i !== current ? 'true' : 'false');
            });
            prevBtn.disabled = current === 0;
            nextBtn.disabled = current === cards.length - 1;
            counterEl.textContent = `${current + 1} of ${cards.length}`;
            const activeCard = slidesEl.children[current];
            if (activeCard) {
                const h = activeCard.offsetHeight;
                if (h > 0) trackEl.style.height = `${h}px`;
            }

            if (focusActiveDot) {
                const activeDot = dotsEl.querySelector(`#sc-dot-${current}`);
                if (activeDot) activeDot.focus();
            }

            this._syncInsightTrackHeight();
        };

        prevBtn.onclick = () => goTo(current - 1, false);
        nextBtn.onclick = () => goTo(current + 1, false);

        /* Keyboard navigation within carousel */
        dotsEl.onkeydown = e => {
            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                goTo(current - 1, true);
            }
            if (e.key === 'ArrowRight') {
                e.preventDefault();
                goTo(current + 1, true);
            }
            if (e.key === 'Home') {
                e.preventDefault();
                goTo(0, true);
            }
            if (e.key === 'End') {
                e.preventDefault();
                goTo(cards.length - 1, true);
            }
        };

        goTo(0, false);
        this._setInsightsAccordionOpen(false);
    }

    _showErr(msg) {
        const box = this.querySelector('#sc-errorBox');
        box.textContent = msg;
        box.style.display = 'block';
    }

    _hideErr() {
        const box = this.querySelector('#sc-errorBox');
        box.style.display = 'none';
    }
}

/* ── Register custom element ──────────────────────────────────────────────── */
if (!customElements.get('summer-calculator')) {
    customElements.define('summer-calculator', SummerCalculator);
}

/* ── Shopify theme editor support ─────────────────────────────────────────── */
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', e => {
        const el = document.querySelector(`#SummerCalculator-${e.detail.sectionId}`);
        if (el) { el._ready = false; el.connectedCallback(); }
    });
}
